// material-ui
import { useTheme } from '@mui/material/styles';
import sasLogo from 'assets/images/users/saslogo.png';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <img src={sasLogo} alt="Food Delivery Admin Icon" width="40" style={{ objectFit: 'contain' }} />
  );
}
